import { render, staticRenderFns } from "./account-configuration.vue?vue&type=template&id=87a0e056&"
import script from "./account-configuration.vue?vue&type=script&lang=js&"
export * from "./account-configuration.vue?vue&type=script&lang=js&"
import style0 from "./account-configuration.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports